export const StoreAction = {
    GET_Data: "GET_Data",
    SET_USER_DATA: "SET_USER_DATA",
    SET_USER_PERMISSION:"SET_USER_PERMISSION",
    SET_TEMPLATE_PERMISSION:"SET_TEMPLATE_PERMISSION",
    SET_TOTAL_FOLLOWUP:"SET_TOTAL_FOLLOWUP"
  };